import React, { PureComponent } from 'react'
import { Card, Col, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import classnames from 'classnames'
import PricingCards from '../../../pricing_cards/PricingCards'
import CompanyProfile from './CompanyProfile'
import showResults from './Show'
import ProfileSettings from './ProfileSettings'

export default class ProfileTabs extends PureComponent {
  constructor (props) {
    super(props)

    this.toggle = this.toggle.bind(this)
    this.state = {
      activeTab: '1'
    }
  }

  toggle (tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      })
    }
  }

  render () {
    return (
      <Col md={12} lg={12} xl={12}>
        <Card>
          <div className='profile__card tabs tabs--bordered-bottom'>
            <div className='tabs__wrap'>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({ active: this.state.activeTab === '1' })}
                    onClick={() => {
                      this.toggle('1')
                    }}
                  >
                    My Profile
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: this.state.activeTab === '2' })}
                    onClick={() => {
                      this.toggle('2')
                    }}
                  >
                    Company Profile
                  </NavLink>
                </NavItem>
                {/* <NavItem>
                  <NavLink
                    className={classnames({ active: this.state.activeTab === '3' })}
                    onClick={() => {
                      this.toggle('3');
                    }}
                  >
                    Billing
                  </NavLink>
                </NavItem> */}
              </Nav>
              <TabContent activeTab={this.state.activeTab}>
                <TabPane tabId='1'>
                  <ProfileSettings user={this.props.user} onSubmit={showResults} />
                  {/* <ProfileActivities /> */}
                </TabPane>
                <TabPane tabId='2'>
                  <CompanyProfile user={this.props.user} />
                </TabPane>
                <TabPane tabId='3'>
                  <PricingCards />
                </TabPane>
              </TabContent>
            </div>
          </div>
        </Card>
      </Col>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/account/profile/components/ProfileTabs.js